/* global axios */

import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    // NOTICE: KAPTION-INTEGRATION - Notification device diagnostics live outside account-scoped APIs.
    super('notification_subscriptions', { accountScoped: false });
  }

  testPush(id) {
    return axios.post(`${this.url}/${id}/test_push`);
  }

  deleteByPushToken(pushToken) {
    return axios.delete(this.url, {
      data: { push_token: pushToken },
    });
  }
}

export default new NotificationSubscriptions();
